import { createSlice } from '@reduxjs/toolkit'

export interface PPAModalState {
  open: boolean
  isPaymentAuth: boolean
}

export const ppaInitialState: PPAModalState = {
  open: false,
  isPaymentAuth: false,
}

export const slice = createSlice({
  name: 'ppaModal',
  initialState: ppaInitialState,
  reducers: {
    togglePPAModal(state: PPAModalState) {
      state.open = !state.open
    },
    openPPAModal(state: PPAModalState) {
      state.open = !state.open
      state.isPaymentAuth = false
    },
    openPPAPaymentAuthModal(state: PPAModalState) {
      state.open = !state.open
      state.isPaymentAuth = true
    },
  },
})

export const { togglePPAModal, openPPAModal, openPPAPaymentAuthModal } = slice.actions

export const ppaModalReducer = slice.reducer
